import React from 'react';
import styles from './AppRatings.module.scss'

export default function AppRatings({rating}) {

    const renderRating = () => {

        const {chart} = rating;

        return chart.map(item => {

            return (
                <div className={styles['rating__score']} key={item.score}>
                    <p className={styles['rating__score__number']}>{item.score}</p>
                    <i className={`fas fa-star ${styles['rating__score__star']}`} aria-hidden='true'/>
                    <div className={styles['rating__score__bar']}>
                        <div
                            className={`${styles['rating__score__bar__fill']} ${styles[`rating__score__bar__fill__${item.score}`]}`}
                            style={{
                                '--rating-percentage': item.percentage > 0 && item.percentage < 6
                                    ? '5%'
                                    : item.percentage + '%'
                            }}
                        />
                    </div>
                    <p className={styles['rating__score__percentage']}>{item.percentage + '%'}</p>
                </div>
            )
        })
    };

    return (
        <div className={styles['rating']}>
            {renderRating()}
        </div>
    )
}